import React, { useState } from 'react';
import { useAuth } from '../../../../context/AuthContext';
import { useBooking } from '../../../../context/BookingContext';
import BookingFilters from './BookingFilters';
import BookingsTable from './BookingsTable';
import Pagination from './Pagination';
import AddNewBooking from './AddNewBooking';
import BookingModal from './bookingModal/BookingModal';
import { toast } from 'sonner';
import './BookingsManagement.css';

const BookingsManagement = () => {
  /*eslint-disable no-unused-vars*/
  const { currentUser, userRole } = useAuth();
  const {
    bookings,
    loading,
    error,
    pagination,
    filters,
    createNewBooking,
    createCompleteNewBooking,
    updateStatus,
    removeBooking,
    updateFilters,
    changePage,
    services,
    vehicleTypes,
    loadingVehicles,
    loadingServices,
    vehiclesError,
    servicesError,
    fetchBookings,
    updateBooking
  } = useBooking();

  const [isAddingBooking, setIsAddingBooking] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleStatusChange = async (bookingId, newStatus) => {
    const result = await updateStatus(bookingId, newStatus);
    if (!result.success) {
      console.error('Failed to update status:', result.error);
    }
  };

  const handleCreateBooking = async (bookingDetails) => {
    try {
      const result = await createCompleteNewBooking(bookingDetails);
      
      if (!result.success) {
        throw new Error(result.error);
      }
      
      setIsAddingBooking(false);
      toast.success('Booking created successfully!');
      
    } catch (error) {
      console.error('Failed to create booking:', error);
      toast.error(`Error creating booking: ${error.message}`);
    }
  };

  const handleEdit = async (bookingId, updatedData) => {
    try {
      const result = await updateBooking(bookingId, updatedData);
      if (!result.success) {
        throw new Error(result.error);
      }
      toast.success('Booking updated successfully!');
      fetchBookings(); // Refresh the bookings list
    } catch (error) {
      console.error('Failed to update booking:', error);
      toast.error(`Error updating booking: ${error.message}`);
      throw error; // Re-throw to let the modal handle the error
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    updateFilters({ [name]: value || null });
  };

  const handleBookingClick = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
  };

  if (loading || loadingVehicles || loadingServices) {
    return <div className="loading">Loading...</div>;
  }

  if (error || vehiclesError || servicesError) {
    return <div className="error">
      Error: {error || vehiclesError || servicesError}
    </div>;
  }

  return (
    <div className="bookings-management">
      <div className="bookings-management__header">
        <h2>Manage Bookings</h2>
        <button
          className="bookings-management__add-btn"
          onClick={() => setIsAddingBooking(true)}
        >
          Add New Booking
        </button>
      </div>

      {isAddingBooking ? (
        <AddNewBooking
          onSubmit={handleCreateBooking}
          vehicleTypes={vehicleTypes}
          services={services}
          onCancel={() => setIsAddingBooking(false)}
        />
      ) : (
        <>
          <BookingFilters
            filters={filters}
            onFilterChange={handleFilterChange}
          />
          <BookingsTable
            bookings={bookings}
            onStatusChange={handleStatusChange}
            onDelete={removeBooking}
            onBookingClick={handleBookingClick}
            onEdit={handleEdit}
          />
          <Pagination
            pagination={pagination}
            onPageChange={changePage}
          />
        </>
      )}

      <BookingModal
        booking={selectedBooking}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onEdit={handleEdit}
      />
    </div>
  );
};

export default BookingsManagement; 